<template>
	<router-view name="loading" />
	<router-view name="popup" v-if="!pageLoading" />
	<router-view name="customerService" />
	<Suspense>
		<router-view />
	</Suspense>
</template>
<script setup>
import { computed, onMounted, getCurrentInstance } from "vue";
import { useHead } from "@vueuse/head";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import UAParser from "ua-parser-js";
import DOMPurify from 'dompurify'
import isServer from "@/_base/isServer";
const storage = !isServer ? require("vue3-storage").useStorage("oright_") : null;
const { proxy } = getCurrentInstance();

const manualJsonLdData = {
	"@context": "https://schema.org",
	"@type": "Organization",
	"name": "Oright 歐萊德",
	"url": "https://shop.oright.com.tw/",
	"logo": "https://shop.oright.com.tw/img/logo_new.png"
};
useHead({
	titleTemplate: (title) => !title ? `${process.env.VUE_APP_TITLE_MAIN}` : `${title} | ${process.env.VUE_APP_TITLE_MAIN}`,
	 script: [
		{
			type: 'application/ld+json',
			"data-hid": "schema-org-graph",
			innerHTML: isServer ? JSON.stringify(manualJsonLdData) : DOMPurify.sanitize(JSON.stringify(manualJsonLdData)),
			tagPosition: 'bodyClose',
		}
	],
});
const store = useStore();
const pageLoading = computed(() => store.state.pageLoadingStore.pageLoading);
const parser = new UAParser();
store.commit("deviceStore/setDeviceInfo", parser.getResult());
// 實作從 router 有 ecid，並且是第一次進入頁面
// 在頁面停留 3 秒後，打 API 'line-shopping/events'
// 要在 includePagesName 才會觸發
const router = useRouter();
const route = useRoute();

onMounted(() => {
	if (!isServer) {
		const excludePagesName = ['Product'];
		const ecid = route.query.ecid;
		if (ecid && !excludePagesName.includes(route.name) && Number(route.query.r) === 8791) {
		setTimeout(() => {
			proxy.axios.post('api/line-shopping/events', {
				ecid,
				event_id: 2,
				redirect_url: process.env.VUE_APP_BASE_URL + route.path,
			});
		}, 3000);
		}
	}
});
</script>
<style lang="scss">
@import "../src/assets/scss/main.scss";
</style>